export const GET_EXHIBITOR_REVIEWS = `
query exhibitorReviews(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: ExhibitorReviewOrderInput,
  $filter: FilterExhibitorReviewInput
){
  exhibitorReviews(
    tenant_id: $tenant_id,
    skip: $skip,
    take: $take,
    orderBy: $orderBy,
    filter: $filter
  ){
    __typename
    ...on ExhibitorReview {
      id
      exhibitor_id
      chair_reviewer_id
      meeting_id
      review
      review_date
      its
      chair {
        id
        contact {
          id
          firstname
          lastname
        }
      }
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GET_EXHIBITOR_REVIEWS_COUNT = `
query exhibitorReviewsCount(
  $tenant_id: Int!,
  $filter: FilterExhibitorReviewInput
){
  exhibitorReviewsCount(
    tenant_id: $tenant_id,
    filter: $filter
  ){
    __typename
    ...on Count {
      count
    }
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const GET_EXHIBITOR_REVIEW_ELIGIBILITY = `
query exhibitorReviewEligibility($tenant_id: Int!, $meeting_id: Int!) {
  exhibitorReviewEligibility(tenant_id: $tenant_id, meeting_id: $meeting_id) {
    can_review
    already_reviewed
    reason
    exhibitor_id
    review
  }
}
`;
